import { Link } from 'react-router-dom';

const TwoColDetailRow = ({
  label,
  value,
  link = '',
  testid = '',
  className,
}) => {
  // this is based off a 12 col grid
  if (value === '' || value === undefined || !value) value = '-';
  if (link !== '')
    value = (
      <Link to={link} reloadDocument>
        {value}
      </Link>
    );

  return (
    <>
      <div className='col-span-3 rounded-sm bg-primary-100 p-2 font-light'>
        {label}
      </div>
      <div
        className={`col-span-9 p-2 font-medium ${className}`}
        data-cy={testid}
      >
        {value}
      </div>
    </>
  );
};

export default TwoColDetailRow;
